import { Outlet, createFileRoute } from "@tanstack/react-router";

import { authUserSchema } from "@/modules/auth/schemes";
import { BackofficeShell } from "@/modules/backoffice/components/BackofficeShell";

export const Route = createFileRoute("/__authed/m")({
	component: RouteComponent,
});

function RouteComponent() {
	const context = Route.useRouteContext();
	const parsedUser = authUserSchema.safeParse("user" in context ? context.user : undefined);
	const user = parsedUser.success ? parsedUser.data : undefined;

	return (
		<BackofficeShell user={user}>
			<Outlet />
		</BackofficeShell>
	);
}
